import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginUser, reset } from "../features/authSlice";
import { IoEye, IoEyeOff } from "react-icons/io5";
import logo from "../assets/img/IotDB.png";
const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [passwordType, setPasswordType] = useState("password");

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }


    const { user, isError, isSuccess, isLoading, message } = useSelector(
        (state) => state.auth
    );


    useEffect(() => {
        if (user || isSuccess) {
            navigate("/home");
        }
        dispatch(reset());
    }, [user, isSuccess, dispatch, navigate]);

    const Auth = (e) => {
        e.preventDefault();
        dispatch(LoginUser({ username, password }));
    };

    return (
        <section className="hero has-background-grey-light is-fullheight is-fullwidth">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <div className="column is-4 is-offset-4">
                        <div className="box">
                            <figure className="avatar">
                                <img src={logo} alt="Logo" />
                            </figure>
                            <hr className="login-hr" />
                            <h1 className="title is-2 has-text-success">Sign In</h1>
                            <form onSubmit={Auth}>
                                {isError ? <div className="notification is-danger is-light">{message}</div> : ""}
                                <div className="field">
                                    <div className="control">
                                        <input
                                            type="text"
                                            className="input"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            placeholder="Username"
                                        />
                                    </div>
                                </div>

                                <div className="field has-addons">
                                    <div className="control is-expanded">
                                        <input type={passwordType} className="input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password' />
                                    </div>
                                    <div className="control">
                                        <span className="button is-success" onClick={togglePassword}>
                                            {passwordType === "password" ? <IoEye /> : <IoEyeOff />}
                                        </span>
                                    </div>
                                </div>
                                <div className="field mt-5">
                                    <button
                                        type="submit"
                                        className={"button is-success is-fullwidth is-medium " + (isLoading ? "is-loading" : "")}
                                    >
                                        Login
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section >

    );
};

export default Login;